// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__7GMBC","invalid":"Checkbox_invalid__JJ+UQ"};